import {createSelector} from 'reselect';
import React, {useContext} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {ProjectContext} from './context';
import {loadStorage} from '../../../Common/localStorage';
import {projectSessionKeys} from '../../../../util/uiconstants';
import selectAllClients from '../../../../reducers/Clients/selectors/selectAllClients';

// Temp code for createSelector will remove
const updateOrgChart = (orgChart, projectId) => {
	let selectedEntitiesId = loadStorage(`${projectSessionKeys.projectdetail}_${projectId}`);
	if (selectedEntitiesId && selectedEntitiesId.entitiesId) {
		orgChart.forEach((ent) => {
			ent.checked = selectedEntitiesId.entitiesId.includes(ent.id);
		});
	}
	return orgChart;
};
const selectOrgChart = createSelector(
	(store, props) => ({orgChart: store.orgChart, projectId: props.projectId}),
	(data) => ({
		orgChart: updateOrgChart(data.orgChart, data.projectId)
	})
);

// let engagementsSummary = useSelector((store) => store.engagementsSummary);
export const projectOrgchartSelector = (props, inputdata) => {
	const projOrgChart = useSelector((store) => selectOrgChart(store, props));
	return projOrgChart;
};

export const clientsSelector = (state) => state.newProject.clients;
export const allClientsSelector = selectAllClients;

// Example of create selector
const getSelectedCountUpdate = (clients, allClients) => {
	// we can filter logic here
	return clients;
};

// selector will execute if clientsSelector and allClientsSelector data changes, we can put more dependencies
export const getSelectedCount = createSelector([clientsSelector, allClientsSelector], getSelectedCountUpdate);

const filterEngagements = (clientEngagements, inputdata) => {
	if (inputdata && inputdata.showAll) {
		// add filterCondition
	}

	return clientEngagements;
};

const selectClientEngagements = createSelector(
	(store, props, inputdata) => ({engagementsSummary: store.engagementsSummary, inputdata: inputdata}),
	(data) => ({
		clientEngagements: filterEngagements(data.engagementsSummary.clientEngagements, data.inputdata)
	})
);

// let engagementsSummary = useSelector((store) => store.engagementsSummary);
export const clientEngagementsSelector = (props, inputdata) => {
	const engagementSummary = useSelector((store) => selectClientEngagements(store, props, inputdata));
	return engagementSummary;
};

export const selectedClientsSelector = () => {
	let selectedClients = useSelector((store) => store.newProject.clients);
	const isEditMode = useSelector((store) => store.isEditMode.activated);
	const isRollForwardMode = useSelector((state) => state.isRollForwardMode);
	const {state, dispatch} = useContext(ProjectContext);
	if (isEditMode || isRollForwardMode) {
		selectedClients = state.clients;
	}
	return selectedClients;
};

export const accessGroupsSelector = () => {
	const accessGroups = useSelector((store) => store.accessGroups);

	return accessGroups;
};

export const orgStructureSelector = () => {
	const orgStructure = useSelector((store) => store.newProject.orgStructure);
	return orgStructure;
};
export const projectUsersSelector = () => {
	const users = useSelector((store) => store.newProject.users);
	return users;
};
